import React from 'react'
import { cn } from 'lib/utils'

interface NotesRailSectionProps {
	title: string
	/** Rendered at the right of the title row, typically a count or a reset. */
	action?: React.ReactNode
	children: React.ReactNode
	className?: string
}

/**
 * Shared chrome for one rail section.
 *
 * Kept as a local component rather than components/ui/card because the rail
 * wants a quieter surface than a page card: the rail is a supporting column, so
 * its sections read as labelled groups rather than competing with the note
 * cards in the feed.
 */
const NotesRailSection: React.FC<NotesRailSectionProps> = ({
	title,
	action,
	children,
	className,
}) => (
	<section className={cn('rounded-xl border border-border bg-card p-4', className)}>
		<div className="mb-3 flex items-center justify-between gap-2">
			<h3 className="m-0 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
				{title}
			</h3>
			{action}
		</div>
		{children}
	</section>
)

export default NotesRailSection
